import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { getOptionsList, getCategories } from 'services/types';
import { Multiselect, Select } from './fields';
import { MultiInput } from './multi-input';

export const CategoryFilter = (props) => {
  const { name = 'vehicle_category', multiple, ...rest } = props;
  const { t } = useTranslation();
  const title = t('form.Категория');

  const items = getCategories();

  // multiple
  if (multiple) {
    return <Multiselect type="multiselect" label={title} additionalComponent={MultiInput} data={items} countDisplayedIcons={1} name={name} {...rest} />;
  }

  // single
  const itemsEl = getOptionsList(items);

  return (
    <Select name={name} type="select" label={title} {...rest}>
      <option value="">{t('filter.Все')}</option>
      {itemsEl}
    </Select>
  );
};

CategoryFilter.propTypes = {
  name: PropTypes.string,
  multiple: PropTypes.bool,
};
